import { Trans } from '@lingui/react'
import type { FC } from 'react'

import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import type { Experiment } from 'types/shopConfig'

type DeliveryDatesForMarketplaceProps = {
  experiment: Experiment
  deliveryTime?: { earliestDays?: number; latestDays?: number } | null
}

const DeliveryDatesForMarketplace: FC<DeliveryDatesForMarketplaceProps> = ({
  experiment,
  deliveryTime,
}) => {
  if (
    !deliveryTime ||
    (typeof deliveryTime.earliestDays !== 'number' &&
      typeof deliveryTime.latestDays !== 'number')
  ) {
    return <Trans id="general.label.product.available" />
  }

  const { earliestDays, latestDays } = deliveryTime

  switch (experiment.variant) {
    case EXPERIMENT_VARIATION.DEFAULT:
      return <Trans id="general.label.product.available" />
    case EXPERIMENT_VARIATION.V1:
      if (
        typeof earliestDays !== 'number' ||
        typeof latestDays !== 'number' ||
        earliestDays === latestDays
      ) {
        const oneDayDelivery = earliestDays ?? latestDays ?? 0

        return (
          <Trans
            id="buyBox.delivery.daysCount"
            values={{ count: oneDayDelivery }}
          />
        )
      } else {
        return (
          <Trans
            id="buyBox.delivery.daysCount"
            values={{ count: `${earliestDays}-${latestDays}` }}
          />
        )
      }
    case EXPERIMENT_VARIATION.V2:
      if (typeof latestDays !== 'number') {
        return <Trans id="general.label.product.available" />
      } else {
        return (
          <Trans
            id="buyBox.delivery.daysCount.deliveryDatesForMpV2"
            values={{ count: latestDays ?? 0 }}
          />
        )
      }
    default:
      return <Trans id="general.label.product.available" />
  }
}

export default DeliveryDatesForMarketplace
